import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  audits: [],
  log_total_pages: 0,
  log_current_page: 0
}

const getters = {
  allAudit: state => state.audits,
  auditTotalPages: state => state.log_total_pages,
  auditCurrentPage: state => state.log_current_page
}

const actions = {
  getAudit ({ commit, rootGetters }, params) {
    api.instance.get('audit/' + params.page)
      .then(function (response) {
        const audits = response.data.audits
        commit(types.RECEIVE_AUDIT, {
          audits: audits,
          page: response.data.page,
          totalPages: response.data.total_pages
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.RECEIVE_AUDIT] (state, { audits, page, totalPages }) {
    state.audits = audits
    state.log_total_pages = totalPages
    state.log_current_page = page
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
